export default function AgendaItemReportController(
  $q,
  $rootScope,
  $scope,
  alerts,
  oversightDataService,
  confirmDialog,
  loaderService,
  ssDialogService
) {
  const vm = this;

  // Set Default Values
  vm.canExpand = vm.status !== 'No Agenda Item Report Added';
  vm.isExpanded = false;
  vm.canDeleteItem = vm.canDelete;

  // Attach Event Handlers
  vm.handleUnattachAgendaItemReport = _handleUnattachAgendaItemReport;
  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;

  function _handleUnattachAgendaItemReport($event) {
    ssDialogService.dialogs.oversight.deleteAgendaItemReportConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Remove Attached Report?',
        message: `Are you sure you want to remove Report "${vm.agendaItemReportDetail.name}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.oversight.deleteAgendaItemReportConfirmDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return oversightDataService.detachAgendaItemReport(vm.agendaItemReportDetail.agendaItemReportInstanceId)
      .then(() => {
        alerts.success('The report has been removed successfully.');
        $rootScope.$broadcast('refreshAgendaItemReports', { agendaItemId: vm.agendaItemId });
        $rootScope.$broadcast('refreshAgendaItem', { agendaItemId: vm.agendaItemId });
        _closeDeleteDialog();
      }).catch(() => {
        alerts.error('Error occurred while removing the report.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.oversight.deleteAgendaItemReportConfirmDialog);
  }
}

AgendaItemReportController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'oversightDataService',
  'confirmDialog',
  'loaderService',
  'ssDialogService'
];
